<script lang="ts" setup>
import { computed, type PropType } from 'vue';

import type { MarketModel } from '@exchange/libs/market/service/src';
import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

const props = defineProps({
  market: { type: Object as PropType<MarketModel> },
  mobile: { type: Boolean, default: false },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  withPrefix: { type: Boolean, default: false },
  withSuffix: { type: Boolean, default: false },
});

const prefix = computed(() => (props.withPrefix ? '@' : undefined));
const suffix = computed(() => (props.withSuffix ? props.order.priceSuffix : undefined));
</script>

<template>
  <div class="order-stop-price">
    <span
      v-if="mobile"
      class="order-stop-price__title"
      >{{ $t('modules.myOrders.header.stop') }}:</span
    >
    <ot-number-display
      v-if="order.triggerPrice ?? 0 > 0"
      class="order-stop-price__value"
      :number="order.triggerPrice"
      :precision="order.getMarketPrecision(market)"
      :prefix="prefix"
      :suffix="suffix"
    />
  </div>
</template>

<style lang="scss">
.order-stop-price {
  &__title {
    color: var(--titles-color);
  }

  &__value {
    color: var(--number-stop-price-color);
  }
}
</style>
